import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth.js';
import { getFirstAccessibleRoute } from './nav-config.js';

interface RequireRolProps {
  roles: string[];
  children: ReactNode;
}

// Guard de ruta por rol — a diferencia de Layout.tsx (autenticado/no
// autenticado), esto es autorización dentro de una sesión ya válida. Sin
// permiso para esta ruta puntual → redirige a la primera ruta del sidebar
// que el rol sí puede ver (mismo orden del menú), no a /login ni a un error
// en blanco — ese caso ("sin sesión") ya lo cubre Layout.tsx antes de llegar acá.
export function RequireRol({ roles, children }: RequireRolProps) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!roles.includes(user.rol)) {
    return <Navigate to={getFirstAccessibleRoute(user.rol)} replace />;
  }

  return <>{children}</>;
}
